export default "__VITE_ASSET__BeYKDr4g__"